import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';

const updateTripPricesMutation = graphql(/* GraphQL */ `
  mutation updateTripPrices($input: UpdateTripPricesInput!) {
    updateTripPrices(input: $input)
  }
`);

export type RoomPriceUpdate = {
  typeId: number;
  price: number;
};

export type UpdateTripPricesInput = {
  tripId: number;
  roomPrices: RoomPriceUpdate[];
};

const useUpdateTripPrices = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useMutation({
    mutationFn: async (input: UpdateTripPricesInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to update trip prices');
      }
      return graphqlRequest(
        updateTripPricesMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    // Removed automatic query invalidation to prevent refresh/login issues
    // Data is updated optimistically in the component
  });
};

export default useUpdateTripPrices;
